<div class="knowledge-reply">
  <app-button (clickButton)="onCreateReply($event)">リクエストに応える</app-button>
  <span class="knowledge-reply-total">{{ totalAnswer }}人が回答</span>
</div>
